/**
 * PageHeader Component
 *
 * Shared header pattern for admin routes.
 *
 * @package MultilingualPressZone
 */

import { el } from '../utils/dom.js';

/**
 * Render a page header.
 *
 * @param {Object} options
 * @param {string} options.title
 * @param {string} [options.description]
 * @param {HTMLElement|Array<HTMLElement>|null} [options.actions]
 * @param {string} [options.className]
 * @param {('mpz'|'settings')} [options.variant='mpz']
 * @return {HTMLElement}
 */
export function PageHeader({
    title,
    description = '',
    actions = null,
    className = '',
    variant = 'mpz',
} = {}) {
    const titleText = String(title || '');
    const descText = String(description || '');

    const actionNodes = Array.isArray(actions)
        ? actions.filter(Boolean)
        : actions
            ? [actions]
            : [];

    if (variant === 'settings') {
        const header = el('div', {
            class: ['presszone-multilingual-settings__header', className].filter(Boolean).join(' ')
        },
            el('h1', {}, titleText),
            descText ? el('p', { class: 'description' }, descText) : null
        );

        if (actionNodes.length) {
            header.appendChild(el('div', { class: 'mpz-page-header__actions' }, ...actionNodes));
        }

        return header;
    }

    return el('div', { class: ['mpz-page-header', className].filter(Boolean).join(' ') },
        el('div', { class: 'mpz-page-header__title' },
            el('h1', {}, titleText),
            descText ? el('p', { class: 'mpz-page-header__description' }, descText) : null
        ),
        actionNodes.length
            ? el('div', { class: 'mpz-page-header__actions' }, ...actionNodes)
            : null
    );
}

export default PageHeader;
